import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import {
    IOrganizacaoERP,
    IOrganizacao,
} from "../../../../Interfaces/Organizacao/Organizacao";

interface IOrganizacaoInfoERP {
    infoERP: IOrganizacaoERP | undefined;
    infoGeral: IOrganizacao | undefined;
}

export default function InfoERP(props: IOrganizacaoInfoERP) {
    const FormMethods = useForm();

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={() => console.log("SemInfoAinda")}
                className="row justify-content-center"
            >
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="COD_ERP_INTEGRACAO"
                        label="Código ERP Integração"
                        readOnly
                        defaultValue={props.infoERP?.COD_ERP_INTEGRACAO}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_EMAIL_SERVICO_SINC_ATENDIMENTO_UAU"
                        label="Email Serviço Sincronizar Atendimento UAU"
                        readOnly
                        defaultValue={
                            props.infoERP?.DS_EMAIL_SERVICO_SINC_ATENDIMENTO_UAU
                        }
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_LOGIN_AD"
                        label="Login AD"
                        readOnly
                        defaultValue={props.infoERP?.DS_LOGIN_AD}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="password"
                        name="DS_SENHA_AD"
                        label="Senha AD"
                        readOnly
                        defaultValue={props.infoERP?.DS_SENHA_AD}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_LOGIN_UAU"
                        label="Login"
                        readOnly
                        defaultValue={props.infoERP?.DS_LOGIN_UAU}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="password"
                        name="DS_SENHA_UAU"
                        label="Senha"
                        readOnly
                        defaultValue={props.infoERP?.DS_SENHA_UAU}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_TOKEN"
                        label="Token"
                        readOnly
                        defaultValue={props.infoERP?.DS_TOKEN}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_URL_WEBSERVICE"
                        label="URL Webservice"
                        readOnly
                        defaultValue={props.infoERP?.DS_URL_WEBSERVICE}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_URL_WEBSERVICE_CAPYS"
                        label="URL Webservice Capys"
                        readOnly
                        defaultValue={props.infoGeral?.INFO_CRM.DS_URL_WEBSERVICE_CAPYS}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_TOKEN_CAPYS"
                        label="Token Integrador Capys"
                        readOnly
                        defaultValue={props.infoGeral?.INFO_CRM.DS_TOKEN_CAPYS}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="ID_SERVICO_SINC_ATENDIMENTO_UAU"
                        label="ID Serviço Sincronizar Atendimento UAU"
                        readOnly
                        defaultValue={
                            props.infoERP?.ID_SERVICO_SINC_ATENDIMENTO_UAU
                        }
                    />
                </div>
                <div className="form-group col-6">
                    <label>
                        <span>Baixa Pagamento UAU</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_BAIXA_PAGAMENTO_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    props.infoERP?.FL_BAIXA_PAGAMENTO_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_BAIXA_PAGAMENTO_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    !props.infoERP?.FL_BAIXA_PAGAMENTO_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-group col-6">
                    <label>
                        <span>CRM Integrado ERP</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_CRM_INTEGRADO_ERP"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    props.infoERP?.FL_CRM_INTEGRADO_ERP
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_CRM_INTEGRADO_ERP"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    !props.infoERP?.FL_CRM_INTEGRADO_ERP
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-group col-6">
                    <label>
                        <span>Serviço de Sincronizar Comentário UAU</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SERVICO_SINC_COMENTARIO_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    props.infoERP
                                        ?.FL_SERVICO_SINC_COMENTARIO_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SERVICO_SINC_COMENTARIO_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    !props.infoERP
                                        ?.FL_SERVICO_SINC_COMENTARIO_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-group col-6">
                    <label>
                        <span>Serviço de Sincronizar Comentário Venda UAU</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SERVICO_SINC_COMENTARIO_VENDA_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    props.infoERP
                                        ?.FL_SERVICO_SINC_COMENTARIO_VENDA_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SERVICO_SINC_COMENTARIO_VENDA_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    !props.infoERP
                                        ?.FL_SERVICO_SINC_COMENTARIO_VENDA_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-group col-6">
                    <label>
                        <span>Sincronizar Documento UAU</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SINC_DOC_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    props.infoERP?.FL_SINC_DOC_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SINC_DOC_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    !props.infoERP?.FL_SINC_DOC_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-group col-6">
                    <label>
                        <span>Sincronizar Preço UAU</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SINC_PRECO_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    props.infoERP?.FL_SINC_PRECO_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SINC_PRECO_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    !props.infoERP?.FL_SINC_PRECO_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-group col-6">
                    <label>
                        <span>Status Unidade UAU</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_STATUS_UNIDADE_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    props.infoERP?.FL_STATUS_UNIDADE_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_STATUS_UNIDADE_UAU"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    !props.infoERP?.FL_STATUS_UNIDADE_UAU
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-group col-12">
                    <label>
                        <span>Serviço de triagem automática</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SERVICO_TRIAGEM_AUTOMATICA"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    props.infoGeral
                                        ?.FL_SERVICO_TRIAGEM_AUTOMATICA
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_SERVICO_TRIAGEM_AUTOMATICA"
                                style={{ transform: "scale(2)" }}
                                checked={
                                    !props.infoGeral
                                        ?.FL_SERVICO_TRIAGEM_AUTOMATICA
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
            </UnForm>
        </FormProvider>
    );
}
